import estiloData from '../../data/Estilodata';

import { useIdioma } from '../../context/IdiomaContext';

import './MiEstilo.css';

function MiEstilo() {
  const { idioma, t } = useIdioma();

  const obtenerEstiloTraducido = (estilo) => {
    if (
      typeof estilo === 'object' &&
      estilo !== null
    ) {
      return (
        estilo[idioma] ||
        estilo.es ||
        ''
      );
    }

    return estilo;
  };

  const primerBloque =
    estiloData.slice(0, 5);

  const segundoBloque =
    estiloData.slice(5, 10);

  return (
    <section className="mi-estilo">
      <div className="mi-estilo-encabezado">
        <h2>
          {t('miEstilo.titulo')}
        </h2>

        <p className="mi-estilo-introduccion">
          {t('miEstilo.introduccion')}
        </p>
      </div>

      <div className="mi-estilo-bloques">
        <ul className="mi-estilo-bloque">
          {primerBloque.map(
            (estilo, index) => (
              <li key={index}>
                <span>
                  {obtenerEstiloTraducido(
                    estilo
                  )}
                </span>
              </li>
            )
          )}
        </ul>

        <ul className="mi-estilo-bloque">
          {segundoBloque.map(
            (estilo, index) => (
              <li key={index + 5}>
                <span>
                  {obtenerEstiloTraducido(
                    estilo
                  )}
                </span>
              </li>
            )
          )}
        </ul>
      </div>
    </section>
  );
}

export default MiEstilo;